var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "add-card",
    width: 60,
    height: 60,
    fill: "black",
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7618 22.2892L28.6424 25.7195C29.0285 27.224 28.122 28.7567 26.6175 29.143L11.5772 33.004C10.0727 33.3903 8.5399 32.4837 8.15367 30.9791L2.83999 10.2804C2.45375 8.77592 3.3603 7.24317 4.86482 6.85694L19.905 2.99587C21.142 2.67835 22.3979 3.23454 23.0202 4.2784",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7588 17.0889V6.1073",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2681 11.5977H33.2495",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquareIcon);
export default __webpack_public_path__ + "static/media/add-square-icon.db6e0121f8e7e642d952dfbf07482e7f.svg";
export { ForwardRef as ReactComponent };